import React from 'react';
import './ContactSection.css';

// Figma/Material style SVG icons
const LocationIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21C12 21 5 13.9375 5 9.5C5 6.18629 8.13401 3.5 12 3.5C15.866 3.5 19 6.18629 19 9.5C19 13.9375 12 21 12 21Z" stroke="#FF7A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="10" r="2.5" stroke="#FF7A1A" strokeWidth="2"/>
  </svg>
);

const PhoneIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5 3.5H9L10 7L8.5 8.5C9.57096 10.5709 11.4291 12.429 13.5 13.5L15 12L18 13V15.5C18 16.0523 17.5523 16.5 17 16.5C11.201 16.5 6.5 11.799 6.5 6C6.5 5.44772 6.94772 5 7.5 5H10V3.5C10 2.94772 9.55228 2.5 9 2.5H7.5C6.94772 2.5 6.5 2.94772 6.5 3.5Z" stroke="#FF7A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const EmailIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke="#FF7A1A" strokeWidth="2"/>
    <path d="M3 7L12 13L21 7" stroke="#FF7A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);



const ContactSection = () => {
  return (
    <div className="contact-container">
      <div className="contact-info">
        <h2>Let's talk with us</h2>
        <p>Questions, comments, or suggestions? Simply fill<br /> in the form and we'll be in touch shortly.</p>
        <div className="contact-details">
          <div className="contact-item">
            <LocationIcon />
            <div>
              1060 North Main Street , Euless,<br />
              Texas 76039, United States.<br /><br />
              13145 North Main Street, Frisco,<br />
              Texas 75035, United States.<br /><br />
              8600 North Macarthur Boulevard, Irving,<br />
              Texas 75063, United States.
            </div>
          </div>
          <div className="contact-item">
            <PhoneIcon />
            <span>+1 682-738-3010</span>
          </div>
          <div className="contact-item">
            <EmailIcon />
            <span>dfwkwality@gmail.com</span>
          </div>
        </div>
      </div>
      <form className="contact-form">
        <div className="form-row">
          <input type="text" placeholder="First Name*" className="input-half input-active" />
          <input type="text" placeholder="Last Name*" className="input-half" />
        </div>
        <input type="email" placeholder="Email*" />
        <input type="text" placeholder="Contact Number*" />
        <textarea placeholder="Your message..." rows={4}></textarea>
        <button type="submit">Send Message</button>
      </form>
    </div>
  );
};
 
export default ContactSection;